import React from 'react';
import useExcelStyles from '../useExcelStyles';
import useNoRowsTemplate from '../useNoRowsOverlay';
import useLoadingOverlay from '../useLoadingOverlay';
import getOptionsRowNodeId from '../../../utils/manage-condition/getOptionsRowNodeId';
import { TOOLTIP_SHOW_DELAY } from '../../../constants';
import type { ConditionOptionsData } from '../../../types/condition';
import type { ExcelStyle, GetContextMenuItemsParams, GridOptions, MenuItemDef } from 'ag-grid-community';

const useGridOptionsSearchConditionOptions = () => {
  const { commonExcelStyles } = useExcelStyles();

  // Excelのスタイル設定
  // ----------------------------------------
  const excelStyles: ExcelStyle[] = [...commonExcelStyles];

  // Overlayの設定
  // ----------------------------------------
  const overlayLoadingTemplate: string = useLoadingOverlay();
  const overlayNoRowsTemplate: string = useNoRowsTemplate();

  // rowNodeIdの設定
  // ----------------------------------------
  const getRowNodeId = (params: ConditionOptionsData) => getOptionsRowNodeId(params);

  // 右クリックメニューの設定
  // ----------------------------------------
  const getContextMenuItems = (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
    // console.log(params);
    if (params.node) {
      // 右クリックメニューの項目
      const menuItems = ['copy', 'copyWithHeaders', 'separator', 'export'];
      return menuItems;
    } else {
      // データrowでないエリアを右クリックしたときはメニューは表示しない
      return [];
    }
  };

  // GridOptions全体
  // ----------------------------------------
  const gridOptions: GridOptions = {
    allowContextMenuWithControlKey: true,
    alwaysShowVerticalScroll: true,
    enableCellTextSelection: false,
    enableRangeSelection: true,
    excelStyles,
    getContextMenuItems,
    getRowNodeId,
    overlayLoadingTemplate,
    overlayNoRowsTemplate,
    rowSelection: 'multiple',
    tooltipShowDelay: TOOLTIP_SHOW_DELAY,
  };
  return { gridOptions };
};

export default useGridOptionsSearchConditionOptions;
